import { Link } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { ArrowUpRight } from 'lucide-react';
import { diamondGlows, DiamondGrid } from '../primitives';

/** "Más sobre Worldcoo" — blue band over a raised-hands photo, with the heart illustration card. */
export function MoreAbout() {
	const { t } = useLingui();
	return (
		<section className="relative flex min-h-[560px] items-center overflow-hidden bg-[#5f93c6] md:min-h-[680px]">
			<div
				aria-hidden
				className="absolute inset-0 scale-110 bg-[url('/redesign/raised-hands.jpg')] bg-cover bg-center blur-[12px]"
			/>
			<div aria-hidden className="absolute inset-0 bg-gradient-to-r from-black/35 via-black/10 to-transparent" />
			{/* Same glow, positioned as Figma has it here: mostly off the top-left corner, so only its
			    lower-right quadrant lands on the band. White instead of brand because this one sits over a
			    photo — in the export it is the one glow filled `rgba(255,255,255,0.4)`. */}
			<DiamondGrid color="#fff" opacity={1} masks={[diamondGlows({ x: '72.5px', y: '-38.5px' })]} />

			<div className="relative mx-auto flex w-full max-w-[1440px] flex-col-reverse items-center gap-10 px-6 py-16 md:py-24 lg:flex-row lg:items-center lg:justify-between xl:px-10">
				<div className="flex max-w-xl flex-col gap-6 text-white">
					<h2 className="text-4xl font-medium tracking-tight md:text-6xl">{t`More about Worldcoo`}</h2>
					<p className="max-w-md text-base text-white/85 md:text-lg">
						{t`Since 2013 we've offered fundraising channels to help NGOs finance their projects. We connect brands, consumers and NGOs to generate real impact through every transaction.`}
					</p>
					<Link
						to="/new/about-us"
						className="flex w-fit items-center gap-2 rounded-full bg-white py-2.5 pr-2.5 pl-5 font-medium text-black transition-opacity hover:opacity-90"
					>
						{t`Learn more`}
						<span className="bg-ink grid size-6 place-items-center rounded-full text-white">
							<ArrowUpRight className="size-4" />
						</span>
					</Link>
				</div>

				<div className="relative shrink-0">
					<div aria-hidden className="bg-brand absolute inset-0 translate-x-5 translate-y-5 rounded-3xl" />
					<img
						src="/redesign/hand-heart-card.svg"
						alt={t`A hand holding a laptop with a heart`}
						className="relative aspect-square w-64 rounded-3xl md:w-80 lg:w-96"
					/>
				</div>
			</div>
		</section>
	);
}
